// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".da116-button{padding:5px 5px 5px 0;font-size:12px}.a5dc2-ellipsis{width:100%;text-align:left;z-index:1}", "",{"version":3,"sources":["webpack://./app/components/BlueprintSelector/style.scss"],"names":[],"mappings":"AAAA,cACE,qBAAA,CACA,cAAA,CAGF,gBACE,UAAA,CACA,eAAA,CACA,SAAA","sourcesContent":[".button {\n  padding: 5px 5px 5px 0;\n  font-size: 12px;\n}\n\n.ellipsis {\n  width: 100%;\n  text-align: left;\n  z-index: 1;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"button": "da116-button",
	"ellipsis": "a5dc2-ellipsis"
};
export default ___CSS_LOADER_EXPORT___;
